<h1 mat-dialog-title>My Profile</h1>
<form [formGroup]="expForm">
  <div class="row details-wrapper mt-5 file-upload-center">
    <div class="col-lg-3 text-style">
      <dg-file-upload
        class=""
        [title]="profileAttachTitle"
        (finalPath)="onFinalPathForProfile($event)"
        [profileAttachment]="isProfileComponent"
        [acceptedType]="profileAcceptedType"
        [maxSize]="profileMaxSize"
        [uniqueAttachmentId]="profileUniqueAttachID"
        [allowFileToAttach]="isAllowFileToAttachProfile"
        [attachId]="profileAttachID"
        (removeProfileImageClicked)="removeImage($event, profileAttachID)"
      >
      </dg-file-upload>

      <div class="user-name-div text-center" *ngIf="userName">
        <div
          class="user-name-text dg-main-heading text-truncate"
          [matTooltip]="
            expForm.controls?.firstname?.value +
            ' ' +
            expForm.controls?.lastname?.value
          "
        >
          {{ expForm.controls["firstname"]?.value }}&nbsp;{{
            expForm.controls["lastname"]?.value
          }}
        </div>
        <div class="d-flex user-id-wrapper justify-content-center mt-2">
          <div *ngIf="userId">
            <mat-icon class="user-id-icon">person</mat-icon>
          </div>
          <div class="user-id-text">
            {{ userId }}
          </div>
          <!--{{ userId | lowercase }}-->
        </div>
      </div>
    </div>
    <div class="col-lg-9 mt-5">
      <div class="row">
        <div class="col-md-4">
          <mat-form-field>
            <mat-label class="label required-field">First Name</mat-label>
            <input sanitized
            [disabled]="true"
              matInput
              id="firstname"
              type="text"
              formControlName="firstname"
              [maxlength]="40"
            />
            <mat-error
              *ngIf="
                expForm.controls['firstname']?.touched &&
                expForm.controls['firstname'].errors &&
                expForm.controls['firstname'].errors.required
              "
              >Please enter First Name.</mat-error
            >
            <mat-error
              *ngIf="
                expForm.controls['firstname']?.touched &&
                expForm.controls['firstname'].errors &&
                expForm.controls['firstname'].errors.pattern
              "
              >Please enter valid First Name.</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <mat-label class="label optional-field">Middle Name</mat-label>
            <input sanitized
            [disabled]="true"
              matInput
              id="middlename"
              type="text"
              formControlName="middlename"
              [maxlength]="40"
            />

            <mat-error
              *ngIf="
                expForm.controls['middlename']?.touched &&
                expForm.controls['middlename'].errors &&
                expForm.controls['middlename'].errors.pattern
              "
              >Please enter valid Middle Name.</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <mat-label class="label required-field">Last Name</mat-label>
            <input sanitized
              matInput
              [disabled]="true"
              id="lastname"
              type="text"
              formControlName="lastname"
              [maxlength]="40"
            />
            <mat-error
              *ngIf="
                expForm.controls['lastname']?.touched &&
                expForm.controls['lastname'].errors &&
                expForm.controls['lastname'].errors.required
              "
              >Please enter Last Name.</mat-error
            >
            <mat-error
              *ngIf="
                expForm.controls['lastname']?.touched &&
                expForm.controls['lastname'].errors &&
                expForm.controls['lastname'].errors.pattern
              "
              >Please enter valid Last Name.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <!--  <div class="col-md-4">
          <mat-label class="small username required-field">Username</mat-label>
          <div>
            <span>
              {{ content.userName }}
            </span>
          </div>
        </div> -->
      <div class="row row-padding-div">
        <div class="col-md-4">
          <mat-form-field>
            <mat-label class="label required-field">Email ID</mat-label>
            <input sanitized
            [disabled]="true"
              matInput
              id="email"
              type="text"
              formControlName="email"
              [maxlength]="35"
              (focusout)="onUniqueEmail($event.target.value)"
            />
            <mat-error
              *ngIf="
                expForm.controls['email']?.touched &&
                expForm.controls['email'].errors &&
                expForm.controls['email'].errors.required
              "
            >
              Please enter Email ID.</mat-error
            >
            <mat-error
              *ngIf="
                expForm.controls['email']?.touched &&
                expForm.controls['email'].errors &&
                expForm.controls['email'].errors.pattern
              "
              >Please enter valid Email ID.</mat-error
            >
          </mat-form-field>
          <mat-error *ngIf="!uniqueEmail" class="uniqueErrors">
            {{ "EMS.Email_Id_Unique" | translate }}
          </mat-error>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <mat-label
              [ngClass]="{
                'required-field':
                  userProfileService?.emsConfig?.isMobileNumberMandatory
              }"
              >Mobile Number</mat-label
            >
            <input sanitized
            [disabled]="true"
              matInput
              type="text"
              id="phone"
              formControlName="phone"
              (input)="onUniqueMobile($event.target.value)"
              [maxlength]="userProfileService?.emsConfig?.mobileNoDigits"
            />
            <mat-error
              *ngIf="
                expForm.controls['phone']?.touched &&
                expForm.controls['phone'].errors &&
                expForm.controls['phone'].errors.pattern
              "
            >
              Please enter valid mobile number
            </mat-error>
          </mat-form-field>
          <mat-error *ngIf="!uniqueMobile" class="uniqueErrors">
            {{ "EMS.Mobile_Unique" | translate }}
          </mat-error>
        </div>
        <div class="col-md-4 dob">
          <!-- <mat-form-field>
            <mat-label class="label optional-field">Choose a date</mat-label>
            <input
              matInput
              [max]="maxDate"
              formControlName="dob"
              [matDatepicker]="picker"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field> -->
        </div>
      </div>
      <div class="row gender-wrapper row-padding-div">
        <mat-label
          [ngClass]="{
            'required-field':
              userProfileService?.emsConfig?.isMobileNumberMandatory
          }"
          >Gender</mat-label
        >

        <mat-radio-group formControlName="gender" [disabled]="true">
          <mat-radio-button [value]="21011">Male</mat-radio-button>
          <mat-radio-button [value]="21012">Female</mat-radio-button>
          <mat-radio-button [value]="21013">Others</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
</form>

<mat-dialog-actions class="justify-content-end dg-btn">
  <button mat-flat-button [mat-dialog-close]="isUpdated">Cancel</button>
  <button mat-flat-button (click)="reset()">Reset</button>
  <button
    color="primary"
    mat-flat-button
    [disabled]="
     true
    "
    (click)="update()"
  >
    Save
  </button>
  <!--  expForm.invalid || checkUpdate() || !uniqueMobile || !uniqueEmail -->
</mat-dialog-actions>
